/** 75 → "1:15", 3725 → "1:02:05" */
export const formatTime = (seconds) => {
  const s = Math.max(0, Math.floor(Number(seconds) || 0));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = String(s % 60).padStart(2, '0');
  return h ? `${h}:${String(m).padStart(2, '0')}:${sec}` : `${m}:${sec}`;
};

/** 3725 → "1h 2m", 75 → "1m", 30 → "<1m" */
export const formatDuration = (seconds) => {
  const s = Math.round(Number(seconds) || 0);
  if (!s) return '';
  if (s < 60) return '<1m';
  const h = Math.floor(s / 3600);
  const m = Math.round((s % 3600) / 60);
  if (h) return `${h}h ${m}m`;
  return m ? `${m}m` : '<1m';
};

/** Flatten modules → ordered lessons with module context. */
export const flattenLessons = (modules = []) =>
  modules.flatMap((m, mi) =>
    m.lessons.map((l, li) => ({ ...l, moduleTitle: m.title, moduleIndex: mi, indexInModule: li }))
  );

/** Previous / next lessons that actually have a video. */
export const neighbours = (lessons, currentId) => {
  const watchable = lessons.filter((l) => l.has_video);
  const idx = watchable.findIndex((l) => l.id === currentId);
  if (idx === -1) {
    const pos = lessons.findIndex((l) => l.id === currentId);
    return {
      prev: [...lessons.slice(0, Math.max(pos, 0))].reverse().find((l) => l.has_video) || null,
      next: lessons.slice(pos + 1).find((l) => l.has_video) || null,
    };
  }
  return { prev: watchable[idx - 1] || null, next: watchable[idx + 1] || null };
};
